import React, { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa6";

interface GoToTopProps {
    parentRef: React.RefObject<HTMLDivElement>;
}

const GoToTop: React.FC<GoToTopProps> = ({ parentRef }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const parent = parentRef.current;

        if (!parent) return;

        const handleScroll = () => {
            setIsVisible(parent.scrollTop > 100);
        };

        parent.addEventListener("scroll", handleScroll);
        return () => {
            parent.removeEventListener("scroll", handleScroll);
        };
    }, [parentRef]);

    const scrollToTop = () => {
        parentRef.current?.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <button
            onClick={scrollToTop}
            className={`z-40 fixed bottom-16 left-1/4 p-3 bg-green-500 text-white rounded-full shadow-lg hover:bg-green-600 transition duration-300 ${isVisible ? "opacity-80" : "opacity-0 pointer-events-none"
                }`}
            aria-label="Go to top"
        >
            <FaArrowUp size={32} />
        </button>
    );
};

export default GoToTop;
